import { CATEGORY_DEPARTMENT_PRESCRIPTIONS } from '../../../constants';
import { PERMISSION } from '../../../components/investigation/share/user_roles';

export function canDeletePrescriptionFromTable({
    category,
    permissions,
    recordType,
}: {
    category: number;
    permissions?: string[];
    recordType?: string;
}): boolean {
    if (recordType === 'stay') {
        return false;
    }
    if (category !== CATEGORY_DEPARTMENT_PRESCRIPTIONS) {
        return false;
    }
    return Boolean(permissions?.includes(PERMISSION.DELETE_SUBMISSION));
}
